/**
 * Utility functions for API operations
 */

/**
 * Returns the base URL for API calls based on the current hostname
 * @returns {string} The base URL for API calls
 */
export const getBaseUrl = () => {
  const currentHost = window.location.hostname;
  if (currentHost.includes('.mikedg.com') || currentHost.includes('.vercel.app')) {
    return 'https://multiball.mikedg.com:8099';
  }
  // Assuming localhost or 127 or some other local thing
  return `http://${currentHost}:8099`;
};
